import { z } from 'zod';
export const usernameSchema = z
  .string()
  .trim()
  .toLowerCase()
  .min(3)
  .max(64)
  .regex(/^[a-z0-9][a-z0-9._-]*$/u);
export const passwordSchema = z.string().normalize('NFC').min(15).max(128);
export const memberSchema = z.object({
  id: z.string(),
  username: usernameSchema,
  name: z.string().trim().min(2).max(80),
  role: z.enum(['admin', 'teacher']),
  status: z.enum(['pending', 'active', 'disabled']),
});
export type TeacherIdentity = z.infer<typeof memberSchema>;
export const identitySessionSchema = z.object({
  authenticated: z.literal(true),
  user: memberSchema,
  csrfToken: z.string().min(32),
  expiresAt: z.string().datetime(),
});
export type IdentitySession = z.infer<typeof identitySessionSchema>;
export const identityLoginSchema = z.object({
  username: usernameSchema,
  password: z.string().normalize('NFC').min(1).max(128),
});
export const invitationSchema = memberSchema.pick({ username: true, name: true, role: true });
export const activationSchema = z.object({
  token: z.string().regex(/^[A-Za-z0-9_-]{43}$/u),
  password: passwordSchema,
});
export const passwordChangeSchema = z.object({
  currentPassword: z.string().normalize('NFC').min(1).max(128),
  password: passwordSchema,
});
